import * as PropTypes from "prop-types"
import { useT } from "react-polyglot-hooks"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import { Charging } from "components/icons/charging"
import { GasStation } from "components/icons/gasStation"
import { Gearshift } from "components/icons/gearShift"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

const Small = styled(Typography)`
  text-transform: capitalize;
  margin-left: 10px;
`

export default function HighlightedFeature(props) {
  const { isEco, fuel, transmission } = props
  const t = useT()

  let icon = isEco ? Charging : GasStation
  let text = t(`car.fuel.${fuel}`)
  if (!isEco && transmission === "automatic") {
    icon = Gearshift
    text = t(`car.transmission.automatic`)
  }

  return (
    <Wrapper>
      <Icon Icon={icon} size="xs" color="gray" />
      <Small variant="small" color="gray">
        {text}
      </Small>
    </Wrapper>
  )
}

HighlightedFeature.propTypes = {
  isEco: PropTypes.bool.isRequired,
  fuel: PropTypes.string.isRequired,
  transmission: PropTypes.string.isRequired
}
